import { MessageCircle, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { trackWorkingLead } from "@/lib/utils";
import draNataliaHero from "@/assets/dra-natalia-hero.png";

const Hero = () => {
  const whatsappUrl = "https://api.whatsapp.com/send?phone=+5511963140057&text=Vim%20pelo%20site%20e%20quero%20agendar%20minha%20consulta.";
  
  const handleWhatsAppClick = () => {
    trackWorkingLead();
  };
  return <section className="relative min-h-[100dvh] flex items-center justify-center overflow-hidden pt-20 sm:pt-24">
      {/* Background layers */}
      <div className="absolute inset-0 bg-gradient-to-br from-background via-secondary/30 to-background z-0" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,hsl(var(--primary)_/_0.05),transparent_70%)] z-0" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,hsl(var(--accent)_/_0.08),transparent_50%)] z-0" />
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 lg:py-16 relative z-10">
        <div className="grid lg:grid-cols-2 gap-6 sm:gap-10 lg:gap-16 items-center">
          {/* Content Section */}
          <div className="space-y-4 sm:space-y-6 lg:space-y-8 text-center lg:text-left order-2 lg:order-1">
            <div className="space-y-3 sm:space-y-4 lg:space-y-5 animate-fade-in-up">
              {/* Badge Superior */}
              <div className="inline-flex items-center gap-2 sm:gap-2.5 px-3 sm:px-4 md:px-5 py-2 sm:py-2.5 rounded-full border border-primary/30 bg-primary/5 backdrop-blur-sm">
                <Sparkles className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-accent flex-shrink-0" />
                <span className="text-foreground font-inter text-[10px] sm:text-xs md:text-sm uppercase tracking-wider font-medium whitespace-nowrap">CRO-SP 132.903</span>
              </div>
              
              {/* Title */}
              <div className="space-y-2 sm:space-y-3">
                <h1 className="font-kiona text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-foreground leading-[0.95] tracking-tight">
                  Dra. Natália Piller
                </h1>
                <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-foreground/90 font-inter font-light">
                  Dentística Estética e Periodontia
                </p>
              </div>
            </div>

            {/* Description */}
            <div className="animate-fade-in-up" style={{
            animationDelay: '0.2s'
          }}>
              <p className="text-xs sm:text-sm md:text-base lg:text-lg text-muted-foreground leading-relaxed font-inter max-w-xl mx-auto lg:mx-0">
                Cada sorriso conta uma história única. Unimos estética dental, saúde gengival e harmonização facial 
                com atendimento acolhedor e técnicas atualizadas. Há <strong>7 anos</strong> criamos transformações naturais 
                que realçam a beleza e a saúde dos nossos pacientes.
              </p>
            </div>

            {/* CTA Button */}
            <div className="flex justify-center lg:justify-start animate-fade-in-up pt-1 sm:pt-2" style={{
            animationDelay: '0.4s'
          }}>
              <Button size="lg" className="hover-lift shadow-gold bg-primary hover:bg-primary/90 text-xs sm:text-sm font-medium h-10 sm:h-12 px-5 sm:px-6 w-full sm:w-auto max-w-xs sm:max-w-none" asChild>
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" onClick={handleWhatsAppClick}>
                  <MessageCircle className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
                  Agende sua Avaliação
                </a>
              </Button>
            </div>
          </div>

          {/* Image Section */}
          <div className="relative animate-fade-in-up order-1 lg:order-2" style={{
          animationDelay: '0.3s'
        }}>
            <div className="relative group max-w-md sm:max-w-lg mx-auto lg:max-w-xl">
              <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-accent/5 rounded-xl sm:rounded-2xl lg:rounded-3xl" />
              <div className="relative rounded-xl sm:rounded-2xl lg:rounded-3xl shadow-gold-lg overflow-hidden aspect-square transition-all duration-700 group-hover:scale-[1.02] group-hover:shadow-gold">
                <img 
                  src={draNataliaHero} 
                  alt="Dra. Natália Piller - Dentista Especialista em Dentística Estética e Periodontia" 
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <div className="absolute inset-0 rounded-xl sm:rounded-2xl lg:rounded-3xl ring-1 ring-primary/20 pointer-events-none" />
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Hero;